import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import QuickEntries from "./components/QuickEntries";
import NewArrivals from "./components/NewArrivals";
import Reviews from "./components/Reviews";
import Database from "./components/Database";
import Forum from "./components/Forum";
import BeginnerGuide from "./components/BeginnerGuide";
import AppDownload from "./components/AppDownload";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <QuickEntries />
        <NewArrivals />
        <Reviews />
        <Database />
        <Forum />
        <BeginnerGuide />
        <AppDownload />
      </main>
      <SiteFooter />
    </div>
  );
}